import { $api } from '@/shared/api/axiosInstance';

type Props = {
    formData: FormData;
    userId: string;
};

export const updatePhoto = async ({ userId, formData }: Props) => {
    const url = `/api/v1/users/${userId}/avatar`;

    const res = await $api.put(url, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });

    return res;
};
